export default "__VITE_ASSET__C_$i2lyT__"